module.exports = __webpack_public_path__ + "img/coloring-slider-sun.fdea0f42.svg";